import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../components/loader";
import Layout from "../layouts/layout";
import GIFT_CARDS from "../api/services/GIFT_CARDS";
import Table from "../containers/_giftCardConsumptionHistoryByCode/table";
import styles from "../styles/_screens/giftCardConsumptionHistoryByCode.module.scss";

const GiftCardConsumptionHistoryByCode = () => {
  const [data, setData] = useState(null);

  const { code } = useParams();

  // FETCH GIFT CARDS PURCHASE HISTORY
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await GIFT_CARDS.get_gift_card_consumption_history_by_code(
          code
        );
        setData(res.history);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  if (!data) {
    return (
      <Layout>
        <div className={styles.container}>
          <div className={styles.wrapper}>
            <div className={styles.main}>
              <Loader />
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.main}>
            <Table data={data} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default GiftCardConsumptionHistoryByCode;
